import * as z from "zod";

/** Storefront GIDs in, the excluded subset of them out. */
export const getMetafieldExcludedExchangeProducts = {
  name: "getMetafieldExcludedExchangeProducts" as const,
  input: z.object({
    productIds: z.array(z.string()),
    variantIds: z.array(z.string()),
  }),
  output: z.object({
    excludedProductIds: z.array(z.string()),
    excludedVariantIds: z.array(z.string()),
  }),
};
